export default ['$stateProvider', $stateProvider => {
    $stateProvider
        .state('app.admin.integration_status', {
            url: '/integration',
            component: 'integrationStatus',
            roles: ['manager']
        });
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/integration/integration.routes.js